/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationDataConnectionsGetDataCommand
 */
export interface FxIdApplicationDataConnectionsGetDataCommand {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationDataConnectionsGetDataCommand
     */
    QueryTitle: string;
}

/**
 * Check if a given object implements the FxIdApplicationDataConnectionsGetDataCommand interface.
 */
export function instanceOfFxIdApplicationDataConnectionsGetDataCommand(value: object): value is FxIdApplicationDataConnectionsGetDataCommand {
    if (!('QueryTitle' in value) || value['QueryTitle'] === undefined) return false;
    return true;
}

export function FxIdApplicationDataConnectionsGetDataCommandFromJSON(json: any): FxIdApplicationDataConnectionsGetDataCommand {
    return FxIdApplicationDataConnectionsGetDataCommandFromJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsGetDataCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationDataConnectionsGetDataCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'QueryTitle': json['QueryTitle'],
    };
}

export function FxIdApplicationDataConnectionsGetDataCommandToJSON(json: any): FxIdApplicationDataConnectionsGetDataCommand {
    return FxIdApplicationDataConnectionsGetDataCommandToJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsGetDataCommandToJSONTyped(value?: FxIdApplicationDataConnectionsGetDataCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'QueryTitle': value['QueryTitle'],
    };
}

